import { fetch } from '../request'
import type { IResponse } from '../interface'
import type { CancelUploadData, XFile } from '../interface/file'

/**
 * 上传文件
 * @param data
 * @returns
 */
export const uploadFile = (data?: any, params?: any) => {
  return fetch('/youyan/upload_media_v3/upload', {
    method: 'POST',
    body: data,
    params,
    timeout: undefined,
    autoErrorHandle: false,
  })
}

/**
 * 获取上传文件进度
 * @param data
 * @returns
 */
export const getUploadStatusList = (params: any) => {
  return fetch<IResponse<XFile[]>>('/youyan/upload_media_v3/batch_status', {
    method: 'GET',
    params,
  })
}

/**
 * 获取上传文件进度
 * @param data
 * @returns
 */
export const getUploadStatus = (params: any) => {
  return fetch('/youyan/upload_media_v3/status/', {
    method: 'GET',
    params,
  })
}

/**
 * 删除上传失败的文件
 * @param data
 * @returns
 */
export const deletePersonalUploadFile = (data: any) => {
  return fetch('/youyan/upload_media_v3/', {
    method: 'DELETE',
    body: data,
  })
}

/**
 * 取消上传
 * @param data
 * @returns
 */
export const cancelUploadFile = (data: CancelUploadData) => {
  return fetch('/youyan/upload_media_v3/cancel/', {
    method: 'POST',
    body: data,
    autoErrorHandle: false,
  })
}

/**
 * 获取上传文件状态ID
 * @param data
 * @returns
 */
export const getUploadId = (data?: any) => {
  return fetch('/youyan/upload_media_v3/prepare_upload', {
    method: 'POST',
    body: data,
    autoErrorHandle: false,
  })
}

// 获取下载临时bucket相关信息
export const getDownloadBucket = (host: string) => {
  return fetch('/youyan/upload_media_v3/oss_credentials/', {
    method: 'POST',
    body: {
      host,
    },
  })
}
